// Generated by AI on 05/27/2026
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useStyles from './ErrorBoundaryStyle';

// Generated by AI on 05/27/2026
const ErrorFallback = ({ error, resetErrorBoundary }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [showDetails, setShowDetails] = useState(false);

    const isProductionEnv = ENVIRONMENT === 'production';

    // Generated by AI on 05/27/2026
    const handleReload = () => {
        window.location.reload();
    };

    // Generated by AI on 05/27/2026
    const handleGoHome = () => {
        resetErrorBoundary();
    };

    return (
        <div className={classes.container}>
            <div className={classes.card}>
                <div className={classes.icon}>⚠️</div>
                <h1 className={classes.title}>
                    {t('ERROR_BOUNDARY_TITLE', 'Something went wrong')}
                </h1>
                <p className={classes.message}>
                    {t('ERROR_BOUNDARY_MESSAGE', 'We apologize for the inconvenience. An unexpected error has occurred.')}
                </p>
                <p className={classes.details}>
                    {t('ERROR_BOUNDARY_DETAILS', 'Our team has been notified and is working to fix the issue. Please try reloading the page or returning to the home page.')}
                </p>

                <div className={classes.buttonContainer}>
                    <button
                        className={`${classes.button} ${classes.primaryButton}`}
                        onClick={handleReload}
                        type="button"
                        data-test-id="error-boundary-reload-button"
                    >
                        {t('ERROR_BOUNDARY_RELOAD_BUTTON', 'Reload Page')}
                    </button>
                    <button
                        className={`${classes.button} ${classes.secondaryButton}`}
                        onClick={handleGoHome}
                        type="button"
                        data-test-id="error-boundary-home-button"
                    >
                        {t('ERROR_BOUNDARY_GO_HOME_BUTTON', 'Go to Home')}
                    </button>
                </div>

                {!isProductionEnv && (
                    <>
                        <button
                            type="button"
                            className={`${classes.button} ${classes.secondaryButton} ${classes.detailsToggleButton}`}
                            onClick={() => setShowDetails((prevShowDetails) => !prevShowDetails)}
                            data-test-id="error-boundary-toggle-details-button"
                        >
                            {showDetails
                                ? t('ERROR_BOUNDARY_HIDE_DETAILS_BUTTON', 'Hide Error Details')
                                : t('ERROR_BOUNDARY_SHOW_DETAILS_BUTTON', 'Show Error Details')}
                        </button>

                        {showDetails && (
                            <div className={classes.errorDetails}>
                                <div className={classes.errorMessage}>
                                    <strong>{t('ERROR_BOUNDARY_ERROR_LABEL', 'Error:')}</strong>
                                    <span>{error.message}</span>
                                </div>
                                {error.stack && (
                                    <div className={classes.stackTraceSection}>
                                        <strong className={classes.stackTraceLabel}>
                                            {t('ERROR_BOUNDARY_STACK_TRACE_LABEL', 'Stack Trace:')}
                                        </strong>
                                        <pre className={classes.stackTrace}>
                                            {error.stack}
                                        </pre>
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

ErrorFallback.propTypes = {
    error: PropTypes.shape({
        message: PropTypes.string,
        stack: PropTypes.string,
    }).isRequired,
    resetErrorBoundary: PropTypes.func.isRequired,
};

export default ErrorFallback;
